<ng-container *ngIf="organisation else asRoot">
    <ng-container *ngTemplateOutlet="overview"></ng-container>
</ng-container>
<ng-template #asRoot>
    <div class="main-content">
        <div class="container-fluid">
            <div class="justify-content-center row">
                <div class="col-12">
                    <div class="header">
                        <div class="header-body">
                            <div class="align-items-center row">
                                <div class="col"><h6 class="header-pretitle">Overview</h6>
                                    <h1 class="header-title text-truncate">Locations</h1></div>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="overview"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #overview>
    <app-overview [query]="query" (dataChange)="data = $event" [windowScroll]="true">
        <div class="header-bar align-items-center row mb-4 gx-3">
            <div class="col">
                <app-filter [(filterTerm)]="term" (onUpdate)="executeQuery()" placeholder="Search"></app-filter>
            </div>
            <div class="col-auto ms-auto d-flex flex-row align-items-center">
                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                        <i class="bi bi-download me-md-2"></i>
                        <span class="d-none d-md-inline">Download</span>
                    </button>
                    <ul class="dropdown-menu">
                        <li><button class="dropdown-item" (click)="downloadLocationsAsExcel()">Locations list</button></li>
                        <li *ngIf="appContext.isAdmin()">
                            <button class="dropdown-item" (click)="downloadLocationRefdataAudit()">
                                BAG and EP-Online audit
                            </button>
                        </li>
                        <li *ngIf="appContext.isAdmin()">
                            <button class="dropdown-item" (click)="downloadBuildingTypeBackfillProposal()">
                                Building type backfill proposal
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div *ngIf="appContext.isAdminOrIntermediary()" class="col-auto">
                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-upload me-md-2"></i>
                        <span class="d-none d-md-inline">Upload</span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a type="button" class="dropdown-item" (click)="uploadLocationsListInput.click()">
                                <span>Locations list</span>
                                <input type="file" hidden (change)="onUploadLocationsList($event.target);" #uploadLocationsListInput>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div *ngIf="appContext.isAdminOrIntermediary()" class="col-auto">
                <button (click)="openLocationDetails(newLocation())" type="button" class="btn btn-primary">
                    <i class="bi bi-plus me-md-2"></i>
                    <span class="d-none d-md-inline">Add Location</span>
                </button>
            </div>
        </div>
        <div class="overview-items pb-4">
            <div class="row mx-0">
                <ng-container *ngFor="let record of data; trackBy: trackByForRecord">
                    <div role="row" class="col-xl-4 col-md-6 col-12" dndDropzone (dndDrop)="onDrop($event, record)"
                         [dndDisableDropIf]="!authorisedForLocationMerge()" [dndDisableDragIf]="!authorisedForLocationMerge()" [dndDraggable]="record">
                        <app-location-overview-item class="h-100 d-flex" [entity]="record"></app-location-overview-item>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
            <span class="h1 mb-2">No locations found</span>
            <span class="text-secondary">Try adjusting your filters or search term</span>
        </div>
    </app-overview>
</ng-template>
